import styled, { keyframes } from 'styled-components';

const shimmerMove = keyframes`
  0% { transform: translate(-35%, 35%); }
  100% { transform: translate(150%, -150%); }
`;

const logoBounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
`;

export const BounceContainer = styled.div`
  animation: ${logoBounce} 1.5s linear infinite;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LogoWrapper = styled.div<{ svgMaskUrl: string }>`
  position: relative;
  /* Width and height mathematically match the 32x40 viewBox aspect ratio of your SVG */
  width: 52px;
  height: 62px;
  overflow: hidden;

  /* Apply the inline SVG mask */
  mask-image: ${(props) => props.svgMaskUrl};
  mask-size: cover;
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-image: ${(props) => props.svgMaskUrl};
  -webkit-mask-size: cover;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  @media (max-width: 768px) {
    width: 42px;
    height: 52px;
  }
  /* Make sure the React SVG stretches to fill the wrapper perfectly */
  svg {
    width: 100%;
    height: 100%;
    display: block;
  }

  &::after {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;

    /* Diagonal shimmer gradient */
    background: linear-gradient(
      45deg,
      rgba(255, 255, 255, 0) 45%,
      rgba(255, 255, 255, 0.7) 50%,
      rgba(255, 255, 255, 0) 55%
    );

    animation: ${shimmerMove} 2.5s linear infinite;
    pointer-events: none;
  }
`;
